/**
 * Основная логика поиска словарей
 */

// Получаем зависимости
var getCurrentLang = function() {
  return window.SEARCH_LANGUAGE ? window.SEARCH_LANGUAGE.getCurrentLang() : 'en';
};

var detectLanguageFromSearch = function(term) {
  return window.SEARCH_LANGUAGE ? window.SEARCH_LANGUAGE.detectLanguageFromSearch(term) : null;
};

var switchLanguageTab = function(lang) {
  if (window.SEARCH_LANGUAGE) {
    window.SEARCH_LANGUAGE.switchLanguageTab(lang);
  }
};

var updateInterfaceTexts = function(lang) {
  if (window.SEARCH_LANGUAGE) {
    window.SEARCH_LANGUAGE.updateInterfaceTexts(lang);
  }
};

var loadSearchResults = function(term, type) {
  if (window.SEARCH_API) {
    window.SEARCH_API.loadSearchResults(term, type);
  }
};

var loadIntroContent = function(lang) {
  if (window.SEARCH_LANGUAGE) {
    window.SEARCH_LANGUAGE.loadIntroContent(lang);
  }
};

// Функция для выполнения поиска через API
function performSearch(event) {
  if (event) {
    event.preventDefault();
  }
  
  // Закрываем dropdown истории при запуске поиска
  if (window.closeHistoryDropdown && typeof window.closeHistoryDropdown === 'function') {
    window.closeHistoryDropdown();
  } else if (window.SEARCH_HISTORY && window.SEARCH_HISTORY.closeHistoryDropdown) {
    window.SEARCH_HISTORY.closeHistoryDropdown();
  }
  
  var currentLang = getCurrentLang();
  var searchTerm = document.getElementById('search').value.trim();

  // Прокручиваем наверх при запуске нового поиска, чтобы пользователь видел начало результатов,
  // а не застрял в середине предыдущей статьи. Если есть PENDING_TERM_*, morphing.js сам
  // доскроллит до нужной статьи после загрузки.
  if (!window.PENDING_TERM_GUID && !window.PENDING_TERM_INDEX) {
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
  }

  // Получаем тип поиска для валидации (поддержка новой кнопки-переключателя)
  var searchType = '';
  var searchTypeHidden = document.getElementById('search-type-hidden');
  if (searchTypeHidden) {
    searchType = searchTypeHidden.value;
  }
  
  // Миграция старых типов
  if (!searchType || searchType === 'exact' || searchType === 'broad' || searchType === 'description' || searchType === 'broad-without-vector') {
    searchType = 'classical';
  } else if (searchType === 'broad-with-vector') {
    searchType = 'smart';
  }
  
  // Если поле поиска пустое, очищаем результаты и загружаем intro контент без перезагрузки
  if (!searchTerm) {
    // Выходим из контекста цепочки: убираем breadcrumb, закрываем chain panel,
    // очищаем CURRENT_HISTORY_ID и ?hid в URL.
    window.CURRENT_HISTORY_ID = null;
    window.PENDING_PARENT_ID = null;
    if (window.syncHistoryIdToUrl) window.syncHistoryIdToUrl(null);
    if (window.CHAIN_PANEL && window.CHAIN_PANEL.update) {
      window.CHAIN_PANEL.update(null);
    }

    // Загружаем intro контент для текущего языка
    loadIntroContent(currentLang);

    // Обновляем URL без параметра search
    var queryString = 'search-type=' + encodeURIComponent(searchType);
    var currentParams = new URLSearchParams(window.location.search);
    if (currentParams.has('debug')) {
      queryString += '&debug=' + encodeURIComponent(currentParams.get('debug'));
    }
    var newUrl = '/' + currentLang + '/?' + queryString;
    window.history.pushState({search: '', 'search-type': searchType, lang: currentLang}, '', newUrl);

    return false;
  }
  
  // Определяем язык по символам в строке поиска
  var detectedLang = detectLanguageFromSearch(searchTerm);
  if (detectedLang !== null && detectedLang !== currentLang) {
    // Переключаем язык полностью (вкладка + тексты)
    if (window.SEARCH_LANGUAGE) {
      window.SEARCH_LANGUAGE.setCurrentLang(detectedLang);
    }
    // Сохраняем язык в cookies
    if (window.SEARCH_UTILS && window.SEARCH_UTILS.saveLanguage) {
      window.SEARCH_UTILS.saveLanguage(detectedLang);
    }
    switchLanguageTab(detectedLang);
    updateInterfaceTexts(detectedLang);
    
    // Обновляем URL на новый язык
    var queryString = 'search=' + encodeURIComponent(searchTerm) + '&search-type=' + encodeURIComponent(searchType);
    
    // Сохраняем параметр debug если он есть
    var currentParams = new URLSearchParams(window.location.search);
    if (currentParams.has('debug')) {
      queryString += '&debug=' + encodeURIComponent(currentParams.get('debug'));
    }
    var newUrl = '/' + detectedLang + '/?' + queryString;
    
    // Добавляем хэш: GUID (стабильный) или legacy index (fallback)
    if (window.PENDING_TERM_GUID) {
      newUrl += '#' + window.PENDING_TERM_GUID;
      // НЕ сбрасываем — будет использован в morphing.js
    } else if (window.PENDING_TERM_INDEX) {
      newUrl += '#term-' + window.PENDING_TERM_INDEX;
      window.PENDING_TERM_INDEX = null; // Сбрасываем после использования
    }

    window.history.pushState({search: searchTerm, 'search-type': searchType, lang: detectedLang}, '', newUrl);

    // Загружаем результаты для нового языка
    loadSearchResults(searchTerm, searchType);
    return false;
  }
  
  // Сохраняем режим поиска в cookies
  if (searchType && window.SEARCH_UTILS && window.SEARCH_UTILS.saveSearchType) {
    window.SEARCH_UTILS.saveSearchType(searchType);
  }
  
  // Обновляем URL без перезагрузки страницы
  var queryString = 'search=' + encodeURIComponent(searchTerm) + '&search-type=' + encodeURIComponent(searchType);
  
  // Сохраняем параметр debug если он есть
  var currentParams = new URLSearchParams(window.location.search);
  if (currentParams.has('debug')) {
    queryString += '&debug=' + encodeURIComponent(currentParams.get('debug'));
  }
  var newUrl = '/' + currentLang + '/?' + queryString;
  
  // Добавляем хэш: GUID (стабильный) или legacy index (fallback)
  // НЕ сбрасываем — будет использован в morphing.js для скролла
  if (window.PENDING_TERM_GUID) {
    newUrl += '#' + window.PENDING_TERM_GUID;
  } else if (window.PENDING_TERM_INDEX) {
    newUrl += '#term-' + window.PENDING_TERM_INDEX;
  }
  
  window.history.pushState({search: searchTerm, 'search-type': searchType}, '', newUrl);
  
  // Загружаем результаты
  loadSearchResults(searchTerm, searchType);
  
  return false;
}

// Экспортируем глобально
window.performSearch = performSearch;
window.SEARCH = {
  performSearch: performSearch
};

// Инициализация при загрузке документа
document.addEventListener('DOMContentLoaded', function() {
  // Переменная для отслеживания кнопки в mousedown для r-тегов
  var lastRMouseDownButton = -1;

  document.addEventListener('mousedown', function(event) {
    var rTag = event.target.closest('r');
    if (rTag) {
      lastRMouseDownButton = (event.button !== undefined) ? event.button : (event.originalEvent && event.originalEvent.button);
    } else {
      lastRMouseDownButton = -1;
    }
  });

  // Делегированный обработчик для кросс-ссылок <r data-t="..."> и <d-ref> (d-src = источник, обычно без data-t)
  // Используем mouseup вместо click, чтобы надежнее определять кнопку мыши
  document.addEventListener('mouseup', function(event) {
    var target = event.target;
    // Если кликнули внутри <r> или <d-ref> или на сам тег
    var rTag = target.closest('r, d-ref');
    if (rTag) {
      var tag = rTag.tagName && rTag.tagName.toLowerCase();
      if ((tag === 'd-ref' || tag === 'd-src') && rTag.hasAttribute('data-ref-collapsed')) {
        return;
      }
      // ПРОВЕРКА КНОПКИ МЫШИ:
      // Нам нужна ТОЛЬКО левая кнопка мыши (button === 0) без клавиш-модификаторов
      var originalEvent = event.originalEvent || event;
      var button = (originalEvent && originalEvent.button !== undefined) ? originalEvent.button : event.button;
      var hasModifiers = event.ctrlKey || event.metaKey || event.shiftKey || event.altKey;

      // Разрешаем только левую кнопку мыши (button 0 в mousedown и mouseup) без модификаторов
      if (button !== 0 || lastRMouseDownButton !== 0 || hasModifiers) {
        return;
      }
      
      event.preventDefault();
      event.stopPropagation();
      
      var term = rTag.getAttribute('data-t') || rTag.innerText.trim();
      // Преобразуем термин в нижний регистр перед использованием
      term = term.toLowerCase();
      var targetLang = rTag.getAttribute('data-l'); // Напр. "EN", "RU"
      var searchInput = document.getElementById('search');
      
      if (searchInput && term) {
        // Если язык ссылки отличается от текущего, нужно переключиться
        if (targetLang) {
          targetLang = targetLang.toLowerCase();
          var currentLang = getCurrentLang();
          if (targetLang !== currentLang) {
            if (window.SEARCH_LANGUAGE) {
              // Используем switchLanguageTab, так как он обновляет и вкладку, и состояние, и куки
              window.SEARCH_LANGUAGE.switchLanguageTab(targetLang);
              // Также принудительно обновляем тексты интерфейса
              window.SEARCH_LANGUAGE.updateInterfaceTexts(targetLang);
            }
          }
        }

        // Помечаем текущую активную запись истории как parent для будущей
        // (иерархия прояснения: этот cross-link создаст ребёнка у текущей статьи).
        // # ⛓️ CURSOR_ANCHOR:search:history-hierarchy
        window.PENDING_PARENT_ID = window.CURRENT_HISTORY_ID || null;
        window.PENDING_PARENT_TS = Date.now();

        // Логика быстрого поиска:
        // Если слово уже в поле поиска - запускаем поиск
        if (searchInput.value.trim() === term) {
          // Запускаем поиск (performSearch сам определит параметры из UI)
          performSearch();
          // Прокручиваем страницу вверх
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          // Снимаем подсветку с предыдущего слова
          var prevActive = document.querySelectorAll('.active-term');
          prevActive.forEach(function(el) {
            el.classList.remove('active-term');
          });

          // Подсвечиваем текущее слово
          rTag.classList.add('active-term');

          // Слово новое - только вставляем в поле (уже в нижнем регистре)
          searchInput.value = term;

          // Фокусируемся на поле поиска (только для десктопа)
          var isMobile = window.SEARCH_UTILS && window.SEARCH_UTILS.isMobileDevice && window.SEARCH_UTILS.isMobileDevice();
          if (!isMobile) {
            searchInput.focus();
          }

          // Если включена настройка поиска одним кликом - запускаем поиск
          var isClickSearchEnabled = window.SETTINGS_CLICK_SEARCH || (window.SEARCH_UTILS && window.SEARCH_UTILS.isClickSearchEnabled && window.SEARCH_UTILS.isClickSearchEnabled());

          if (isClickSearchEnabled) {
            setTimeout(function() {
              performSearch();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 50);
          }
        }
      }
    }
  });
});

